export function useLogout() {
  const { $auth } = useNuxtApp()
  const router = useRouter()
  const toast = useToast()
  const $analytics = useAnalytics()
  const capacitorAuth = useCapacitorAuth()

  const logout = async (options: { showToast?: boolean } = {}) => {
    const { showToast = true } = options

    if ($auth.loggedIn) {
      $analytics.trackElementClicked({ elementType: 'link', text: 'log out' })
      await router.push('/login')
      await $auth.logout()
      await capacitorAuth.clearTokens()

      if (showToast) {
        setTimeout(() => {
          toast.add({
            severity: 'info',
            summary: 'You have been logged out.',
            detail: 'Sign back in to continue.',
            life: 8000,
          })
        }, 100)
      }
    }
  }

  return {
    logout,
  }
}
